<template>
  <div id="app">
    <Index v-if="pageType === '1'" />
    <ProductDetails v-else-if="pageType === '2'" />
  </div>
</template>
<script>
import Index from "@/views/Index.vue";
import ProductDetails from "@/views/ProductDetails.vue";
export default {
  name: "App",
  components: { Index, ProductDetails },
  data() {
    return {
      pageType: "-1",
      timer: Date.now(),
    };
  },
  methods: {
    setStyle(gray) {
      // 设置样式
      let css;
      if(window.$EV && window.$EV.isMobile) {
        css = `
          body, div, dl, dt, dd, ul, ol, li, h1, h2, h3, h4, h5, h6, form, fieldset, input, textarea, p, th, td {
            font-size: 3.256vw;
          }
          p {
            margin: 0 0 3.72vw 0;
          }
        `
      } else {
        css = `
          body, div, dl, dt, dd, ul, ol, li, h1, h2, h3, h4, h5, h6, form, fieldset, input, textarea, p, th, td {
            font-size: 0.729vw;
          }
          p {
            margin: 0 0 0.83vw 0;
          }
          .parse-page::-webkit-scrollbar, .lcs-container::-webkit-scrollbar, .css-product-details::-webkit-scrollbar {
            width: 0.417vw !important;
            height: 0.417vw !important;
            background: transparent;
          }
          .parse-page::-webkit-scrollbar-thumb, .lcs-container::-webkit-scrollbar-thumb, .css-product-details::-webkit-scrollbar-thumb {
            background-color: rgba(0, 0, 0, 0.3) !important;
            border-radius: 0.21vw !important;
          }
          .parse-page::-webkit-scrollbar-corner, .lcs-container::-webkit-scrollbar-corner, .css-product-details::-webkit-scrollbar-corner {
            background: transparent;
            height: 0;
            width: 0
          }
        `
      }
      // 网站置灰
      if(gray) {
        css += `html {
          filter: grayscale(100%);
          -webkit-filter: grayscale(100%);
          -moz-filter: grayscale(100%);
          -ms-filter: grayscale(100%);
          -o-filter: grayscale(100%);
        }`
      }
      let style = document.createElement('style')
      style.setAttribute('type', 'text/css')
      let cssText = document.createTextNode(css)
      style.appendChild(cssText)
      let head = document.querySelector('head')
      head.appendChild(style)
    },
    getSiteInfo() {
      const { pathname: site } = location
      const ps = (site.split('/') || []).reduce((p, c) => {
        if (c && c != '#') {
          p.push(c.replaceAll('/', ''))
        }
        return p
      }, [])

      return ps
    },
    async init() {
      const ps = this.getSiteInfo()
      const siteName = ps[0]
      let flag = false
      try {
        const gray = await this.$request.request({ url: `/${siteName}/grey.json?_=${this.timer}` })
        flag = gray && gray.flag
      } catch (error) {}
      this.setStyle(flag)
    },
  },
  created() {
    this.init()
    if(!location.pathname || location.pathname == '/'){
      location.pathname = '/css';
    }
    if (location.pathname.includes("product")) {
      this.pageType = "2";
    } else {
      this.pageType = "1";
    }
  },
};
</script>
<style>
@font-face {
  font-family: "思源黑体";
  src: url('./font/SourceHanSansCN-Normal.ttf');
}
body, div, dl, dt, dd, ul, ol, li, h1, h2, h3, h4, h5, h6, form, fieldset, input, textarea, p, th, td {
  font-family: 思源黑体, "Microsoft YaHei";
}
</style>
